import styled from 'styled-components';
import { colors } from '../../../../constants/colors';

interface LabelText {
  color?: string;
}

export const StyledFileInputWrapper = styled.label`
  display: inline-block;
  border: 2px solid #ccc;
  padding: 10px;
  cursor: pointer;
  width: 100%;
  text-align: center;
`;

export const StyledFileInput = styled.input`
  display: none;
`;

export const StyledLabel = styled.p<LabelText>`
  color: ${({ color }) => color || colors.blue};
  margin: 0;
`;
